import BaseModel from '../base/BaseModel.model';
import User from '../security/user.model';

export default class ProporsalUsersEvaluators extends BaseModel {

   public porposalId?:number | null;
   
   public userId?: string | null;
   public evaluatorType?: any | null; // will be deleted

   public evaluationTypeId?:number | null;
   
   public fechaLimite?: string | null;
   public user?: User | null;

   constructor(){
       super();
       this.init();
   }

    init(){
       this.porposalId = null;
       this.userId = null;
       //this.evaluatorType = null;
       this.fechaLimite = null;
       this.user = null;
       this.deleted = false;
    }

}